import { Box, Breadcrumbs, Typography, styled } from '@mui/material'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import { Link as RouterLink } from 'react-router-dom'

export interface BreadcrumbItem {
  label: string
  path?: string
}

interface GicBreadcrumbsProps {
  items: BreadcrumbItem[]
}

const StyledRouterLink = styled(RouterLink)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main,
  fontWeight: 500,
  '&:hover': {
    textDecoration: 'underline',
  },
}))

export default function GicBreadcrumbs({ items }: GicBreadcrumbsProps) {
  return (
    <Box sx={{ mb: 2, mt: 1 }}>
      <Breadcrumbs
        separator={<NavigateNextIcon fontSize="small" />}
        aria-label="breadcrumb"
      >
        {items.map((item, index) => {
          const isLast = index === items.length - 1

          return isLast ? (
            <Typography
              key={item.label}
              color="text.primary"
              fontWeight="medium"
            >
              {item.label}
            </Typography>
          ) : (
            <StyledRouterLink key={item.label} to={item.path || '#'}>
              {item.label}
            </StyledRouterLink>
          )
        })}
      </Breadcrumbs>
    </Box>
  )
}
